// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
		suggestionMobileStyle:"style2",
// 		suggestionBlocks: [
// 			{type: 'suggestions', label: 'Suggestions', status: 'active', number: 3},
// 			{type: 'collections', label: 'Collections', status: 'active', number: 2},
// 			{type: 'products', label: 'Products', status: 'active', number: 6},
// 			{type: 'pages', label: 'Pages', status: 'active', number: 2},
// 		],
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
})();